module.exports = __webpack_public_path__ + "img/mastercard-v2.svg";